export default __webpack_public_path__ + "static/laffayette_comic_pro-webfont-3831ae204812c8507f804780f0f92b94.ttf";